export const SYSTEM_ROLE_ADMIN = "admin";
export const SYSTEM_ROLE_INTERNAL = "user_internal";
export const SYSTEM_ROLE_EXTERNAL = "user_external";

export const SYSTEM_ROLES = [
  { value: SYSTEM_ROLE_ADMIN, label: "Admin" },
  { value: SYSTEM_ROLE_INTERNAL, label: "User (Internal)" },
  { value: SYSTEM_ROLE_EXTERNAL, label: "User (External)" },
];

export const SYSTEM_ROLE_LABELS = SYSTEM_ROLES.reduce((acc, r) => {
  acc[r.value] = r.label;
  return acc;
}, {});

const norm = (v) => (v || "").toString().toLowerCase();

export const isSystemAdmin = (role) => norm(role) === SYSTEM_ROLE_ADMIN;
export const isInternalUser = (role) => norm(role) === SYSTEM_ROLE_INTERNAL;
export const isExternalUser = (role) => norm(role) === SYSTEM_ROLE_EXTERNAL;
